import type { ProjectCredit } from "@/mocks/gallery";

interface ProjectCreditsProps {
  credits: ProjectCredit[];
}

export default function ProjectCredits({ credits }: ProjectCreditsProps) {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-14 border-t border-white/10 bg-[#0a0a0a]">
      <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        <div className="lg:col-span-4">
          <h2
            className="font-black uppercase leading-[0.95] tracking-[-0.02em] text-white"
            style={{ fontSize: "clamp(28px, 3.4vw, 48px)" }}
          >
            Credits
          </h2>
        </div>

        <div className="lg:col-span-8">
          <ul className="divide-y divide-white/10 border-t border-white/10">
            {credits.map((c) => (
              <li
                key={c.role}
                className="flex flex-col md:flex-row md:items-center md:justify-between py-5 gap-2"
              >
                <span className="text-[11px] uppercase tracking-[0.4em] text-white/50">
                  {c.role}
                </span>
                <span className="text-white/90 text-lg md:text-xl font-light">
                  {c.name}
                </span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}